export default __webpack_public_path__ + "static/media/slide_logo-KIU.540059ac.png";